<template>
    <div class="control">
        <div class="select is-fullwidth">
        <select>
            <option v-for="option in options" :key="option.value">{{ option.name }}</option>
        </select>
        </div>
    </div>
</template>
<script>
export default {
  name: 'Dropdown',
  props: {
    options: Array
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/forms/Dropdown.vue